import React, { useMemo } from 'react';
import { Menu } from '@mui/material';
import type { MenuProps, PopoverVirtualElement } from '@mui/material';

/* eslint-disable-next-line @typescript-eslint/no-empty-object-type */
interface CustomMenuProps extends MenuProps {}

const CustomMenu: React.FC<CustomMenuProps> = ({
  anchorEl,
  children,
  anchorOrigin = { vertical: 'bottom', horizontal: 'left' },
  transformOrigin = { vertical: 'top', horizontal: 'left' },
  ...props
}) => {
  const resolvedAnchorEl = useMemo(() => {
    if (typeof anchorEl === 'function') return anchorEl();
    return anchorEl as Element | PopoverVirtualElement | null;
  }, [anchorEl]);

  const calculatedMaxHeight = useMemo(() => {
    if (
      resolvedAnchorEl &&
      'getBoundingClientRect' in resolvedAnchorEl &&
      typeof resolvedAnchorEl.getBoundingClientRect === 'function'
    ) {
      const rect = resolvedAnchorEl.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom - 16;
      return Math.max(spaceBelow, 150);
    }
    return 300;
  }, [resolvedAnchorEl]);

  return (
    <Menu
      elevation={3}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      PaperProps={{
        style: {
          maxHeight: calculatedMaxHeight,
          overflowY: 'auto',
        },
      }}
      anchorEl={resolvedAnchorEl}
      {...props}
    >
      {children}
    </Menu>
  );
};

export default CustomMenu;
